import React, { useEffect, useState } from 'react';
import { useTypedDispatch, useTypedSelector } from '@/store';
import { useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Item from './Item';
import DroppableWrapper from '@/components/DndWrappers/Droppable';
import LoadingMask from '@/components/LoadingMask';

import { fetchDayNotes, fetchWeekNotes } from '@/store/notes/thunkActions';
import { openNote } from '@/store/core';
import { getSortedNotes } from '@/store/notes/selectors';

import type { OpenedNoteState } from '@/types/store/core';

const NotesCol: React.FC = () => {
  const { pathname } = useLocation();
  const { dayInMs } = useParams();
  const dispatch = useTypedDispatch();
  const [t] = useTranslation();

  const notes = useTypedSelector(state => getSortedNotes(state, +dayInMs));

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onOpenNote = (payload: OpenedNoteState) => dispatch(openNote(payload));
  const onFetchNotes = async () => {
    setIsLoading(true);
    const currentPage = pathname.split('/')[1];
    if (currentPage === 'week') {
      await dispatch(fetchWeekNotes(+dayInMs));
    } else if (currentPage === 'day') {
      await dispatch(fetchDayNotes(+dayInMs));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    onFetchNotes();
    // eslint-disable-next-line
  }, [dayInMs]);

  return (
    <div className="notes">
      <LoadingMask isLoading={isLoading} zIndex={20} width={40} height={40} />

      <div className="notes__head">
        <div className="notes__title">{t('notes')}</div>
        <div className="notes__add" onClick={() => onOpenNote({ type: 'new' })}>
          + {t('addNotes')}
        </div>
      </div>
      <DroppableWrapper isDropDisabled droppableId="notes" className="notes__body">
        {notes.map((note, index) => (
          <Item
            key={note._id}
            index={index}
            item={note}
            onClick={() => onOpenNote({ type: 'edit', _id: note._id })}
          />
        ))}
      </DroppableWrapper>
    </div>
  );
};

export default NotesCol;
